import { CookieModalController } from 'modules/application/cookieModal/CookieModalController';
import { OnboardingController } from 'modules/onboarding/OnboardingController';
import CookieModalView from 'modules/application/cookieModal/CookieModalView.html';
import OnboardingSidebarView from 'modules/onboarding/sidebar/OnboardingSidebarView.html';
import './AuthLayout.scss';
import { CHECKLIST_BUTTON_VIEW } from './AuthLayoutSegmentEvent';
export class AuthLayoutController {
    static $inject = ['$scope', 'LoadingService', 'AccountService2', 'ContextProcessorService', 'SidebarService', 'ModalService', 'TenantService', 'SegmentService', 'OnboardingService', '$window'];
    constructor($scope, LoadingService, AccountService2, ContextProcessorService, SidebarService, ModalService, TenantService, SegmentService, OnboardingService, $window) {
        'ngInject';
        this.AccountService2 = AccountService2;
        this.ContextProcessorService = ContextProcessorService;
        this.SidebarService = SidebarService;
        this.ModalService = ModalService;
        this.TenantService = TenantService;
        this.SegmentService = SegmentService;
        this.OnboardingService = OnboardingService;
        this.$window = $window;
        this.canViewOnboardingSidebar = false;
        this.onboardingOverallProgress = 0;
        $scope.isLoadingGlobal = LoadingService.isLoadingGlobal;
        $scope.isLoadingLocal = LoadingService.isLoadingLocal;
        this.onInit();
        // Ensure $onDestroy() is called when scope is destroyed
        $scope.$on('$destroy', () => {
            if (typeof this.$onDestroy === 'function') {
                this.$onDestroy();
            }
        });
    }
    async onInit() {
        await this.ContextProcessorService.waitForInitialization();
        await this.checkFeatures();
        await this.showCookieModal();
        this.setCanViewOnboardingSidebar();
        // Rerender button if sidebar is updated (progress or visibility)
        this.onboardingSidebarUpdateHandler = (_) => this.setCanViewOnboardingSidebar();
        this.$window.addEventListener('onOnboardingSidebarUpdate', this.onboardingSidebarUpdateHandler);
    }
    $onDestroy() {
        if (this.onboardingSidebarUpdateHandler) {
            this.$window.removeEventListener('onOnboardingSidebarUpdate', this.onboardingSidebarUpdateHandler);
            this.onboardingSidebarUpdateHandler = null;
        }
    }
    async checkFeatures() {
        this.isOrganizationEnabled = await this.TenantService.isOrganizationEnabled();
    }
    async showCookieModal() {
        const account = await this.AccountService2.me();
        const cookies = account.extras?.cookies &&
            (JSON.parse(account.extras.cookies));
        if (!cookies?.portalAcceptedCookiesDate) {
            await this.ModalService.showModal({
                template: CookieModalView,
                controller: CookieModalController,
                controllerAs: '$ctrl',
            });
        }
    }
    async setCanViewOnboardingSidebar() {
        this.canViewOnboardingSidebar = await this.OnboardingService.shouldShowOnboardingSidebar();
        if (this.canViewOnboardingSidebar) {
            this.createTrackOnboardingButtonView();
            this.onboardingOverallProgress = await this.OnboardingService.getOnboardingSidebarProgress();
        }
    }
    async createTrackOnboardingButtonView() {
        const isTracked = sessionStorage.getItem(CHECKLIST_BUTTON_VIEW);
        if (isTracked !== 'true') {
            sessionStorage.setItem(CHECKLIST_BUTTON_VIEW, 'true');
            this.SegmentService.createOrganizationTrack(CHECKLIST_BUTTON_VIEW);
        }
    }
    openOnboardingSidebar() {
        this.SidebarService.showSidebar({
            template: OnboardingSidebarView,
            controller: OnboardingController,
            margin: false,
            position: 'right',
            width: 580,
            id: 'checklist',
        });
    }
}
